import { settingsUrl } from "./url";

// Public routes
export const PUBLIC = "/public";
export const PUBLIC_REPORT = `${PUBLIC}/report`;
export const PUBLIC_REPORT_REPORT_ID = `${PUBLIC_REPORT}/:reportId`;
export const PUBLIC_DASHBOARD = `${PUBLIC}/dashboard`;
export const PUBLIC_DASHBOARD_DASHBOARD_ID = `${PUBLIC_DASHBOARD}/:dashboardId`;

// Private routes
export const HOME = "/home";
export const COMMAND_CENTER = "/cc";
export const COMMAND_CENTER_AUTHORIZATION = `${COMMAND_CENTER}/authorization`;
export const COMMAND_CENTER_ACCOUNT_MANAGEMENT = `${COMMAND_CENTER}/account-management`;
export const COMMAND_CENTER_VENDOR_MANAGEMENT = `${COMMAND_CENTER}/vendor-management`;
export const COMMAND_CENTER_SUPPORT = `${COMMAND_CENTER}/support`;
export const SUPPORT = "/support";
export const JOBS = "/jobs";
export const JOBS_JOB_ID = `${JOBS}/:jobId`;
export const FILE = "/file";
export const FILE_UPLOAD = `${FILE}/upload`;
export const FILE_ID = `${FILE}/:id`;
export const NOTIFICATIONS = "/notifications";
export const NOTIFICATIONS_NOTIFICATION_ID = `${NOTIFICATIONS}/:notificationId`;
export const SETTINGS = "/settings";
export const SETTINGS_TAB_NAME = `${SETTINGS}/:tabName`;
export const SETTINGS_PROFILE = settingsUrl("profile");
export const SETTINGS_ACCOUNT = settingsUrl("account");
export const SETTINGS_ORGANIZATION = settingsUrl("organization");
export const SETTINGS_JURISDICTION = settingsUrl("jurisdiction");
export const SETTINGS_COMMODITIES = settingsUrl("commodities");
export const SETTINGS_DEPARTMENTS = settingsUrl("departments");
export const SETTINGS_UTILITIES = settingsUrl("utilities");
export const SETTINGS_INTEGRATIONS = settingsUrl("integrations");
export const EXPLORE = "/explore";
export const EXPLORE_DASHBOARD = `${EXPLORE}/dashboard`;
export const EXPLORE_DASHBOARD_DASHBOARD_ID = `${EXPLORE_DASHBOARD}/:dashboardId`;
export const EXPLORE_REPORTS = `${EXPLORE}/reports`;
export const EXPLORE_REPORTS_REPORT_ID = `${EXPLORE_REPORTS}/:reportId`;
export const EXPLORE_REPORTS_EDIT = `${EXPLORE_REPORTS}/:reportId/edit`;
export const COMPLIANCE = "/compliance";
export const COMPLIANCE_OVERVIEW = `${COMPLIANCE}/overview`;
export const COMPLIANCE_PROGRAMS = `${COMPLIANCE}/programs`;
export const COMPLIANCE_MATCHES = `${COMPLIANCE}/matches`;
export const COMPLIANCE_TASKS = `${COMPLIANCE}/tasks`;
export const COMPLIANCE_TASKS_TASK_ID = `${COMPLIANCE_TASKS}/:taskId`;
export const COMPLIANCE_TRACKING = `${COMPLIANCE}/tracking`;
export const COMPLIANCE_TRACKING_TRACKING_ID = `${COMPLIANCE_TRACKING}/:trackingId`;
export const COMPLIANCE_SUBMISSIONS = `${COMPLIANCE}/submissions`;
export const COMPLIANCE_HISTORY = `${COMPLIANCE}/history`;
export const COMPLIANCE_WORKBOOKS = `${COMPLIANCE}/workbooks`;
export const COMPLIANCE_EXPORT = `${COMPLIANCE}/export`;
export const COMPLIANCE_DASHBOARDS = `${COMPLIANCE}/dashboards`;
export const ENERGY_MANAGEMENT = "/energy-management";
export const ENERGY_MANAGEMENT_INITIATIVES = `${ENERGY_MANAGEMENT}/initiatives`;
export const ENERGY_MANAGEMENT_INITIATIVES_INITIATIVE_ID = `${ENERGY_MANAGEMENT_INITIATIVES}/:initiativeId`;
export const ENERGY_MANAGEMENT_LOCATIONS = `${ENERGY_MANAGEMENT}/locations`;
export const ENERGY_MANAGEMENT_LOCATIONS_NEW = `${ENERGY_MANAGEMENT_LOCATIONS}/new`;
export const ENERGY_MANAGEMENT_LOCATIONS_PROPERTY_ID = `${ENERGY_MANAGEMENT_LOCATIONS}/:propertyId`;
export const ENERGY_MANAGEMENT_LOCATIONS_PROPERTY_ID_EDIT = `${ENERGY_MANAGEMENT_LOCATIONS_PROPERTY_ID}/edit`;
export const ENERGY_MANAGEMENT_METERS = `${ENERGY_MANAGEMENT}/meters`;
export const ENERGY_MANAGEMENT_METERS_NEW = `${ENERGY_MANAGEMENT_METERS}/new`;
export const ENERGY_MANAGEMENT_METERS_METER_ID = `${ENERGY_MANAGEMENT_METERS}/:meterId`;
export const ENERGY_MANAGEMENT_METERS_METER_ID_EDIT = `${ENERGY_MANAGEMENT_METERS_METER_ID}/edit`;
export const ENERGY_MANAGEMENT_STATEMENTS = `${ENERGY_MANAGEMENT}/statements`;
export const ENERGY_MANAGEMENT_STATEMENTS_STATEMENT_ID = `${ENERGY_MANAGEMENT_STATEMENTS}/:statementId`;
export const ENERGY_MANAGEMENT_UTILITIES = `${ENERGY_MANAGEMENT}/utilities`;
export const ENERGY_MANAGEMENT_UTILITIES_ORG_VENDOR_ID = `${ENERGY_MANAGEMENT_UTILITIES}/:orgVendorId`;
export const ENERGY_MANAGEMENT_BILLING_ACCOUNTS = `${ENERGY_MANAGEMENT}/billing-accounts`;
export const ENERGY_MANAGEMENT_BILLING_ACCOUNTS_BILLING_ACCOUNT_ID = `${ENERGY_MANAGEMENT_BILLING_ACCOUNTS}/:billingAccountId`;
export const ENERGY_MANAGEMENT_SERVICE_ACCOUNTS = `${ENERGY_MANAGEMENT}/service-accounts`;
export const ENERGY_MANAGEMENT_SERVICE_ACCOUNTS_SERVICE_ACCOUNT_ID = `${ENERGY_MANAGEMENT_SERVICE_ACCOUNTS}/:serviceAccountId`;
export const ENERGY_MANAGEMENT_INSIGHTS = `${ENERGY_MANAGEMENT}/insights`;
export const PROGRAMS = "/programs";
export const PROGRAMS_OVERVIEW = `${PROGRAMS}/overview`;
export const PROGRAMS_PROGRAMS = `${PROGRAMS}/programs`;
export const PROGRAMS_PROGRAMS_PROGRAM_ID = `${PROGRAMS_PROGRAMS}/:programId`;
export const PROGRAMS_PROGRAMS_PROGRAM_ID_CRITERIA = `${PROGRAMS_PROGRAMS_PROGRAM_ID}/criteria`;
export const PROGRAMS_PROGRAMS_PROGRAM_ID_EDIT = `${PROGRAMS_PROGRAMS_PROGRAM_ID}/edit`;
export const PROGRAMS_PROGRAMS_PROGRAM_ID_DEADLINES = `${PROGRAMS_PROGRAMS_PROGRAM_ID}/deadlines`;
export const PROGRAMS_PROGRAMS_PROGRAM_ID_EMISSIONS = `${PROGRAMS_PROGRAMS_PROGRAM_ID}/emissions`;
export const PROGRAMS_PROGRAMS_PROGRAM_ID_PROPERTY_MATCHES = `${PROGRAMS_PROGRAMS_PROGRAM_ID}/property-matches`;
export const PROGRAMS_PROGRAMS_PROGRAM_ID_PROPERTIES = `${PROGRAMS_PROGRAMS_PROGRAM_ID}/properties`;
export const PROGRAMS_PROGRAMS_PROGRAM_ID_PROPERTY_SHARE_REQUESTS = `${PROGRAMS_PROGRAMS_PROGRAM_ID}/property-share-requests`;
export const PROGRAMS_PROGRAMS_PROGRAM_ID_COMMUNICATIONS = `${PROGRAMS_PROGRAMS_PROGRAM_ID}/communications`;
// Cycle-scoped routes
export const PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES = `${PROGRAMS_PROGRAMS_PROGRAM_ID}/cycles`;
export const PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_NEW = `${PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES}/new`;
export const PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID = `${PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES}/:cycleId`;
export const PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_COMPLIANCE = `${PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID}/compliance`;
export const PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_ENROLLMENTS = `${PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID}/enrollments`;
export const PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_SUBMISSIONS = `${PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID}/submissions`;
export const PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_FORMS = `${PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID}/forms`;
export const PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_FORMS_NEW = `${PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_FORMS}/new`;
export const PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_FORMS_FORM_ID_EDIT = `${PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_FORMS}/:formId/edit`;
export const PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_FORMS_FORM_ID_PREVIEW = `${PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_FORMS}/:formId/preview`;
export const PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_PORTALS = `${PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID}/portals`;
export const PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_PORTALS_NEW = `${PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_PORTALS}/new`;
export const PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_PORTALS_PORTAL_ID_EDIT = `${PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_PORTALS}/:portalId/edit`;
export const PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_PORTALS_PORTAL_ID_PREVIEW = `${PROGRAMS_PROGRAMS_PROGRAM_ID_CYCLES_CYCLE_ID_PORTALS}/:portalId/preview`;
export const PROGRAMS_PROGRAMS_NEW = `${PROGRAMS}/programs/new`;
// (Removed) PROGRAMS_PROPERTIES / PROGRAMS_FORMS / PROGRAMS_COMMUNICATIONS /
// PROGRAMS_PROPERTY_SHARE_REQUESTS / PROGRAMS_MAP — all replaced by per-program
// routes under PROGRAMS_PROGRAMS_PROGRAM_ID. The sidebar resolves these links
// from the current-program selector; the map view is now a tab on the
// per-program Properties page.
export const PROGRAMS_REPORTS_CITYWIDE = `${PROGRAMS}/reports/citywide`;
export const PROGRAMS_PUBLIC = `${PROGRAMS}/public`;
export const PROGRAMS_PUBLIC_PROGRAM_ID = `${PROGRAMS_PUBLIC}/:programId`;
export const PROGRAMS_COVERAGE_LISTS = `${PROGRAMS}/coverage-lists`;
